import { FileUploader } from "react-drag-drop-files";

import "./ImageUpload.css";
const fileTypes = ["JPG", "PNG", "GIF", "JPEG"];

function ImageUpload({ onChange, file }) {
  return (
    <div className="">
      {file && (
        <div style={{ background: "blue" }} className="image-preview">
          <img src={URL.createObjectURL(file)} alt="preview" />
        </div>
      )}
      <FileUploader
        classes="image-upload"
        handleChange={onChange}
        name="file"
        types={fileTypes}
      />
    </div>
  );
}

export default ImageUpload;
